var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('tree-node',{attrs:{"nodes":_vm.nodes,"currentChange":_vm.currentChange},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var node = ref.node;
return [_vm._t("default",null,{"node":node})]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }